<template>
  <div class="mainDiv">
    <h3>{{ courseName }}</h3>
    <div style="position: relative">
      <el-tabs v-model="activeName" @tab-click="tabChange">
        <el-tab-pane label="课件架构" name="1">
          <CourseTree />
        </el-tab-pane>
        <!-- <el-tab-pane label="知识点对照表附件" name="2">
          <CourseKnowledgeComparisonAttachment />
        </el-tab-pane> -->
      </el-tabs>
      <div style="position: absolute; right: 8px; top: -6px">
        <el-button type="info" @click="toTutorialsAndLive">
          面授直播课表
        </el-button>
        <el-button type="info" @click="back"> 返回 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CourseTree from './courseTree.vue'
import CourseKnowledgeComparisonAttachment from './Course-knowledgeComparisonAttachment.vue'
export default {
  components: {
    CourseTree,
    CourseKnowledgeComparisonAttachment,
  },
  data() {
    return {
      courseId: this.$route.query.courseId,
      courseName: this.$route.query.courseName,
      id: this.$route.query.id,
      activeName: '1',
      type: '',
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.type = val.query.tab
      },
      immediate: true,
    },
  },
  methods: {
    tabChange(tab) {
      if (tab.name === this.type) return
      let query = {
        tab: tab.name,
      }
      this.$router.push({
        query,
      })
    },
    toTutorialsAndLive() {
      this.$router.push(
        `/MyClassroomTutorialsAndLive?type=1&tution=1&courseId=${this.courseId}&courseName=${this.courseName}&id=${this.id}`
      )
    },
    back() {
      this.$router.push('/MyClassroomTution')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>